export interface PuiSelectRenderer {
  item: PuiSelectItemRenderer;
  option?: PuiSelectItemRenderer;
}

export interface PuiSelectItemRenderer {
  render: (any: any, escape: (string: any) => string) => string;
}
